<template>
  <div class="base-setup" @click="showIconSelect = false">
    <el-form ref="baseSetting" :model="setup" label-position="top" label-width="10px">
      <el-form-item label="PC表单图标">
        <el-popover placement="bottom" width="320px" trigger="click">
          <div class="center icon" slot="reference">
            <el-image style="width: 46px; height: 46px" :src="getLocalIcon(setup.pcLogo)"></el-image>
          </div>
          <div class="appColorsBox">
            <div class="body">
              <div v-for="item in 12" :key="item">
                <div class="center body-icon" @click="setup.pcLogo = item" :class="{ active: item === setup.pcLogo }">
                  <el-image style="width: 46px; height: 46px" :src="getLocalIcon(item)"></el-image>
                </div>
              </div>
            </div>
          </div>
        </el-popover>
      </el-form-item>
      <el-form-item label="表单名称" :rules="getRule('请输入表单名称')" prop="formName">
        <el-input v-model="setup.formName" size="medium"></el-input>
      </el-form-item>
      <el-form-item label="所在分组" class="group">
        <!-- <el-input v-model="setup.groupName" ></el-input> -->
        <el-select v-model="setup.groupId" placeholder="请选择" style="width: 100%">
          <el-option :label="item.name" :value="item.id" v-for="item in groupList" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="表单说明">
        <el-input placeholder="请输入表单说明" v-model="setup.remark" type="textarea" show-word-limit
          :autosize="{ minRows: 2, maxRows: 5 }" maxlength="500"></el-input>
      </el-form-item>
      <el-form-item label="数据标题">
        <el-select v-model="setup.dataName" placeholder="请选择" multiple style="width: 100%">
          <el-option :label="item.title" :value="item.code" v-for="(item, index) in dataNameList"
            :key="item.code + index"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getAllFormGroups } from "@/api/design";
export default {
  name: "FormBaseSetting",
  data() {
    return {
      showIconSelect: false,
      rules: {
        formName: [{}],
      },
      url: "",
      groupList: [],
    };
  },
  created() {
    this.url = `${process.env.VUE_APP_BASE_URL}/cloud-admin/file/upload?type=0`;
    let menuBar = JSON.parse(localStorage.getItem("menuBar"));
    getAllFormGroups((menuBar && menuBar.id) || 0).then((res) => {
      // console.log(res, "res");
      this.groupList = res.data;
    });
  },
  computed: {
    setup() {
      console.log(this.$store.state.design, "111");
      return this.$store.state.design;
    },
    dataNameList() {
      return this.$store.state.dataNameList;
    },
    groupName() {
      return this.$store.state.routerList.find(
        (item) => item.id === this.setup.groupId
      ).name;
    },
  },

  methods: {
    getLocalIcon(icon) {
      try {
        return require(`@/assets/icons/svg/${icon}.png`);
      } catch (e) {
        return icon;
      }
    },
    handleAvatarSuccessPc(res) {
      if (res && res.code === 200) {
        this.setup.pcLogo = res.data;
      }
    },
    handleAvatarSuccess(res) {
      if (res && res.code === 200) {
        this.setup.logo = res.data;
      }
    },
    getRule(msg) {
      return [{ required: true, message: msg, trigger: "blur" }];
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-select-dropdown {
  display: none;
}

.icon-select {
  display: flex;
  flex-wrap: wrap;

  i {
    cursor: pointer;
    font-size: large;
    padding: 10px;
    max-width: 38px !important;

    &:hover {
      box-shadow: 0 0 10px 2px #c2c2c2;
    }
  }
}

/deep/ .select-u {
  width: 100%;
}

.base-setup {
  overflow: auto;
  width: 245px;
  height: calc(100vh - 170px);
  // background: #ffffff;
  box-sizing: content-box;
  padding: 0 20px;

  /deep/ .el-form-item__label {
    padding: 0;
    font-weight: bold;
  }

  /deep/ .el-form-item {
    margin-bottom: 5px;
    width: 100%;
  }
}

/deep/ .group {
  .el-select {
    width: calc(100% - 100px);
  }

  .el-button {
    margin-left: 10px;
    width: 86px;
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f8f8f8;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #e8e8e8;
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #107fff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}

.avatar {
  width: 78px;
  height: 78px;
  display: block;
}

.icon {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  cursor: pointer;

  .svg-icon {
    width: 40px;
    height: 40px;
    color: #fff;
  }
}

.appColorsBox {
  padding: 8px;

  .top {
    display: flex;
    gap: 16px;
    padding-bottom: 18px;
    padding-left: 8px;

    span {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      cursor: pointer;
      box-sizing: border-box;

      &.active {
        border: 2px solid #b0d5ff;
      }
    }
  }
}

.body {
  width: 300px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  background: #f5f6f8;
  padding: 10px;
  border-radius: 4px;
}

.body-icon {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  cursor: pointer;
  color: #fff;

  .svg-icon {
    width: 30px;
    height: 30px;
    color: #fff;
  }

  &.active {
    border: 2px solid #b0d5ff;
  }
}
</style>
